/**
 * FreshCards - Main Entry Point
 * Phase 0: Foundations
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider, createTheme } from "@mantine/core";
import App from "./App";
import "./index.css";
import "@mantine/core/styles.css";
import "@blocknote/core/style.css";
import "@blocknote/mantine/style.css";
import { initializeStorage } from "./core/storage-adapter";

// Initialize storage adapters before app renders
initializeStorage().catch(console.error);

const theme = createTheme({
  primaryColor: "blue",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  colors: {
    blue: ["#dbeafe", "#bfdbfe", "#93c5fd", "#60a5fa", "#3b82f6", "#2563eb", "#1d4ed8", "#1e40af", "#1e3a8a", "#172554"],
  },
});

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <App />
    </MantineProvider>
  </React.StrictMode>
);